import React from 'react';

export const LanguageContext = React.createContext({
    lang: {
        options: ['EN', 'RO'],
        selected: 'EN',
    },
    changeLanguage: lang => { },
});




// WEBPACK FOOTER //
// ./src/LanguageContext.js